// hooks/useVendorDataSheet.js
import { useState, useCallback, useEffect } from "react";

function buildInitialState({ dataSheet, submittedDataSheet }) {
  if (!dataSheet || typeof dataSheet !== "object") return {};

  console.log("submittedDataSheet build:", dataSheet, submittedDataSheet);

  return Object.fromEntries(
    Object.entries(dataSheet).map(([section, fields]) => [
      section,
      Object.fromEntries(
        Object.keys(fields ?? {}).map((label) => {
          const previous = submittedDataSheet?.find(
            (entry) => entry.section === section && entry.label === label,
          );

          // console.log("submittedDataSheet entry for", {
          //   section,
          //   label,
          //   previous,
          // });
          return [
            label,
            {
              radio: previous?.radio ?? null,
              remarks: previous?.remarks ?? "",
            },
          ];
        }),
      ),
    ]),
  );
}

export function useVendorDataSheet({
  dataSheet,
  onSaveDataSheet,
  submittedDataSheet,
}) {
  console.log("dataShweet in hook:", dataSheet?.dataSheet, submittedDataSheet);
  const [vendorState, setVendorState] = useState(() =>
    buildInitialState({
      dataSheet: dataSheet?.dataSheet ?? {},
      submittedDataSheet,
    }),
  );
  const [isEditable, setEditable] = useState(false);

  useEffect(() => {
    // wait until BOTH are ready
    if (!dataSheet || !Object.keys(dataSheet).length) return;

    setVendorState(
      buildInitialState({
        dataSheet: dataSheet?.dataSheet,
        submittedDataSheet,
      }),
    );
  }, [submittedDataSheet, dataSheet]); // ← both in deps

  const handleChange = useCallback((section, label, field, value) => {
    setVendorState((prev) => {
      const prevSection = prev[section] ?? {};
      const prevField = prevSection[label] ?? { radio: null, remarks: "" };
      return {
        ...prev,
        [section]: {
          ...prevSection,
          [label]: { ...prevField, [field]: value },
        },
      };
    });
  }, []);

  const resetSection = useCallback((section) => {
    setVendorState((prev) => {
      if (!prev[section]) return prev;
      return {
        ...prev,
        [section]: Object.fromEntries(
          Object.keys(prev[section]).map((label) => [
            label,
            { radio: null, remarks: "" },
          ]),
        ),
      };
    });
  }, []);

  const getFieldState = useCallback(
    (section, label) =>
      vendorState[section]?.[label] ?? { radio: null, remarks: "" },
    [vendorState],
  );

  const onSave = useCallback(() => {
    const changes = [];

    Object.entries(vendorState).forEach(([section, fields]) => {
      Object.entries(fields ?? {}).forEach(([label, fieldState]) => {
        const { radio, remarks } = fieldState;
        if (!radio && !remarks) return;

        changes.push({
          section,
          label,
          value: dataSheet?.[section]?.[label] ?? "",
          ...(radio && { radio }),
          ...(remarks && { remarks }),
        });
      });
    });

    onSaveDataSheet({ row: dataSheet?.row, changes });
    setEditable(false);
  }, [vendorState, dataSheet, onSaveDataSheet]);

  return {
    vendorState,
    isEditable,
    setEditable,
    handleChange,
    onChange: handleChange,
    resetSection,
    getFieldState,
    onSave,
  };
}
